export const SET_WHITELIST = 'SET_WHITELIST';
